if (!customElements.get("info-blocks")) {
  class InfoBlocks extends HTMLElement {
    constructor() {
      super();
      this.renderSlider();
      // this.initHoverEffect();
    }
    
    renderSlider() {
      new Swiper(this, {
        spaceBetween: 26,
        slidesPerView: 1.3,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: { slidesPerView: 2 },
          768: { slidesPerView: 2.3 },
          991: { slidesPerView: 3.2 },
        },
      });
    }

    initHoverEffect() {
      const blocks = this.querySelectorAll(".info-block");
      const resetColors = () =>
        blocks.forEach((b) =>
          b
            .querySelector(".info-block__heading")
            ?.style.setProperty("color", "#0F305B")
        );

      blocks.forEach((block) => {
        const heading = block.querySelector(".info-block__heading");

        block.addEventListener("mouseenter", () => {
          blocks.forEach((el) => {
            const h = el.querySelector(".info-block__heading");
            h?.style.setProperty("color", el === block ? "#0F305B" : "#6E8297");
          });
        });

        block.addEventListener("mouseleave", resetColors);
      });

      // Set initial colors on load
      resetColors();
    }
  }

  customElements.define("info-blocks", InfoBlocks);
}
